import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import { Modal } from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import { useRecoilState } from "recoil";
import { langState, langText } from "../../recoil/lang";

const ResponseModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const [lang, setLang] = useRecoilState<number>(langState);

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  useEffect(() => {}, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        modal: "responseModal",
      }}
      showCloseIcon={false}
      animationDuration={150}
      closeOnOverlayClick={false}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <div className="cleckButton">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clerk.svg`}
                width={40}
                height={40}
                alt="ic"
              />
            </div>
            <h6> {langText.responseModal_title[lang]}</h6>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>

          <div className="modal_content">
            <div className="textarea">asdas</div>
            <div className="textarea response">
              <div className="commentBox">
                {langText.responseModal_badge_complete[lang]}
              </div>
            </div>
            <div className="commentBox">
              {langText.responseModal_badge_comment[lang]}
            </div>
            <button className="submitButton" onClick={onCloseModal}>
              {langText.responseModal_button_check[lang]}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ResponseModal;

const Style = styled.div`
  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    padding: 8% 5%;
  }

  .modal_header {
    width: 100%;
    height: 20%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 3%;

    h6 {
      font-size: 24px;
      line-height: 36px;
      color: #ffffff;
    }

    .closeIcon {
      position: absolute;
      top: -20%;
      right: -2%;
      cursor: pointer;
    }
  }
  .modal_content {
    width: 100%;
    height: 80%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .commentBox {
    background: #f7f7f7;
    color: #40977f;
    font-size: 16px;
    line-height: 30px;
    padding: 0 14px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .typeListWrap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1.6%;
    .typeButton {
      padding: 14px 0;
      padding-top: 25px;
      background: #e5e5e5;
      border: 2px solid #e5e5e5;
      border-radius: 5px;
      font-size: 20px;
      line-height: 22px;
      color: #555555;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      white-space: pre-line;
    }
    .typeButton.active {
      background: #555555;
      color: #ffffff;
    }
  }

  .textarea {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: flex-start;
    width: 100%;
    height: 40%;
    background: #343434;
    border: 2px solid #555555;
    padding: 20px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 300;
    color: #ffffff;
    margin-bottom: 10px;
  }
  .textarea.response {
    border: 2px solid #40977f;
    gap: 12px;
    margin-bottom: 30px;

    .commentBox {
      background: #40977f;
      color: #ffffff;
      line-height: 26px;
    }
  }

  .cleckButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: #4dd2ae;
    border-radius: 100px;
    cursor: pointer;
    z-index: 999;
  }

  .submitButton {
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }
`;
